'use es6';

import UrlRegexFactory from './factories/UrlRegexFactory';
import UrlParts from './parts/UrlParts';
var URL_WITH_PROTOCOL_REGEX = UrlRegexFactory({
  protocol: UrlParts.protocolRequired,
  protocolRequired: true
});
export default URL_WITH_PROTOCOL_REGEX;